import http from "@/axios-config";

import { useUserState } from "../stores/user-state";

export async function deleteUser(id) {
    const userState = useUserState();

    const response = await http
        .delete(`api/users/${id}`)
        .catch(function (response) {
            const error = {
                message: response,
                status: 500,
            };
            return error;
        });
    userState.users = response.data.users;
    return response;
}

export async function getUsers() {
    const response = await http.get("/api/users/index").catch();
    return response.data;
}
